import * as tf from "@tensorflow/tfjs";

const LoadModel = async (Image) => {
  // const Model = await tf.loadLayersModel('http://localhost:4001/Model/model.json')
  const Model = await tf.loadLayersModel('https://ancient-plateau-86572.herokuapp.com/Model/model.json')
  let tensorImg = tf.browser.fromPixels(Image).resizeNearestNeighbor([100, 100]).toFloat().expandDims();
  return indexOfMax(await Model.predict(tensorImg).data());

}
function indexOfMax(arr) {
  let max = arr[0];
  let maxIndex = 0;

  for (let i = 1; i < arr.length; i++) {
    if (arr[i] > max) {
      maxIndex = i;
      max = arr[i];
    }
  }

  return maxIndex;
}
export default LoadModel;

